import React from 'react';

export const TenantConfigurationIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-configuration"
      style={props.style || { color: '#757575', transform: 'scale(0.7)' }}
    />
  );
};
